<template>
  <div class="">
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="container mx-auto max-w-[1200px] overflow-y-auto px-4 sm:px-6 xl:px-0">
      <section id="UserProfile" v-if="profileInfo"
        class="w-full py-3 mt-10 flex flex-col md:flex-row flex-wrap gap-10 md:items-start justify-center">
        <!-- Profile Card -->

         <div
          class="bg-white shadow-md rounded-lg p-5 text-center w-full md:w-[280px] mt-10"
        >
          <div class="flex flex-col items-center relative"> 


            <!-- {{ profileInfo.data.profile }} -->

            <div v-if="profileInfo.data.profile == ''">
              <!-- <p
                class="border rounded-full w-24 h-24 flex items-center justify-center text-4xl text-black capitalize bg-gray-200 font-semibold"
              >
                {{ profileInfo.data.user.slice(0, 1) }}
              </p> -->
              <!-- src="@/assets/new/profile.png" -->

              <img
                src="@/assets/newd/Group 151.png"
                alt="Profile Picture"
                class="w-24 h-24 rounded-full"
              />

            </div>
            <div v-else class="">

              

              <img
                :src="profileInfo.data.profile"
                alt="Profile Picture"
                class="w-24 h-24 rounded-full"
              />
            </div> 

            <p class="text-xs bg-blues text-white px-2 py-1 absolute top-0 right-0 rounded-lg cursor-pointer" @click="changeProfile = true">Edit</p>

            <form v-if="changeProfile" @submit.prevent="imageHandles" class="py-4 flex flex-col items-center justify-center gap-4 w-full">
                <input type="file" name="" id="image_uploads" required class="w-full">
                <div class="flex items-center gap-3"> 
                  <button type="submit" class="bg-blues text-white px-2 py-1 rounded-lg text-xs">Change Photo</button>
                  <button @click="changeProfile = false" class="bg-red-500 text-white px-2 py-1 rounded-lg text-xs">Cancel</button>
                </div>
                

              </form>

          </div>

          
          <div class="mt-4">
            <p class="text-lg font-bold capitalize">
              {{ profileInfo.data.user }}
            </p>
            <p class="text-sm text-gray-500">
              {{ profileInfo.data.designation }}
            </p>
          </div>
          <div class="mt-10 flex justify-center gap-5">
            <a :href="profileInfo.data.github" target="_blank" title="GitHub">
              <img
                src="@/assets/githubprofile.svg"
                class="h-6 w-6 cursor-pointer"
                alt="GitHub"
              />
            </a>
            <a
              :href="profileInfo.data.linkedin"
              target="_blank"
              title="LinkedIn"
              class="text-gray-500 hover:text-blue-500"
            >
              <svg
                fill="currentColor"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0"
                class="w-6 h-6"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="none"
                  d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                ></path>
                <circle cx="4" cy="4" r="2" stroke="none"></circle>
              </svg>
            </a>
          </div>
        </div>

        <!-- Personal Details Card -->
        <div class="w-full max-w-full md:max-w-[720px] flex flex-col gap-5 bg-white px-4 sm:px-6 md:py-10">
          <div class="flex flex-wrap gap-2 items-center capitalize overflow-x-auto sm:flex">
            <button v-for="tab in tabs" :key="tab" @click="active_tab = tab" :class="[
              'px-4 py-2 rounded-md capitalize whitespace-nowrap',
              active_tab == tab ? 'bg-blues text-white' : 'bg-gray-200',
            ]">
              {{ tab }}
            </button>
          </div>
          <div v-if="active_tab == 'profile details'" class="w-full flex flex-col gap-5">
            <div class="flex justify-between items-center gap-2">
              <div class="text-[#0085DB] text-xl font-bold mt-2 px-4">
                Personal Details
              </div>
            </div>

            <div class="overflow-x-auto">
              <table class="min-w-full bg-white border-gray-300">
                <tbody>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Full Name
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm">
                      {{ profileInfo.data.user }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Role
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm uppercase">
                      {{ this.userInfo.user.permission }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Email
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm">
                      {{ profileInfo.data.Email }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Mobile
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm">
                      {{ profileInfo.data.mobile }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800">
                      Department
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600">
                      {{ profileInfo.data.department || "None" }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Address
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm">
                      {{ profileInfo.data.address }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-2 px-4 font-medium text-gray-800 text-sm">
                      Description
                    </td>
                    <td>:</td>
                    <td class="py-2 px-4 text-gray-600 text-sm">
                     
                      {{
                        profileInfo.data.description.slice(0, 180) || "None"
                      }}
                      <p v-if="profileInfo.data.description.length > 180">
                        ...More
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-4 flex flex-wrap justify-center gap-3">
              <div @click="ProfileEdit" class="relative">
                <button class="px-4 py-2 rounded-lg text-white bg-[#0F172A] text-xs">
                  Edit
                </button>
              </div>

              <div @click="ChangePasswordPopup" class="relative">
                <button class="px-4 py-2 rounded-lg text-white bg-[#0F172A] text-xs">
                  Change Password
                </button>
              </div>

              <!-- <router-link
                  class="flex items-center gap-2 px-4 py-2 text-white bg-[#0085DB] rounded-lg"
                >
                  <img
                    src="@/assets/newd/changee.png"
                    alt="Change Icon"
                    class="w-5 h-5"
                  />
                  <span class="text-sm font-medium">Change Password</span>
                </router-link> -->
            </div>

          </div>
          <div v-if="active_tab == 'accessible course'" class="w-full md:w-[800px] flex flex-col gap-5 py-5">
            <div class="w-full flex flex-wrap justify-between items-center gap-5 hidden">
              <div v-for="course in course_list" :key="course" @click="redirectCourse"
                class="w-full md:w-[320px] xl:w-[350px] bg-lime-300 rounded-lg cursor-pointer">
                <div class="w-full rounded-lg flex flex-col">
                  <div class="w-full h-[300px]">
                    <img :src="course.thumbnail" alt="Course Thumbnail"
                      class="w-full h-full object-cover rounded-t-lg" />
                  </div>
                  <div class="w-full p-5 flex flex-col gap-3">
                    <h1 class="font-semibold text-black text-xl">
                      {{ course.title }}
                    </h1>
                    <p class="text-gray-700 font-medium text-md">
                      {{ course.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full flex flex-col gap-5 py-5">
              <div class="w-full overflow-x-auto">
                <table class="min-w-full text-sm">
                  <thead>
                    <tr class="text-left bg-[#18469d] text whitespace-nowrap text-sm capitalize">
                      <th class="px-4 py-3">S.No</th>
                      <th class="px-4 py-3">Title</th>
                      <th class="px-4 py-3 hidden">description</th>
                      <th class="px-4 py-3">Course Code</th>
                      <th class="px-4 py-3">Section</th>
                      <th class="px-4 py-3">created at</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(course, index) in course_list" :key="course.id" @click="redirectCourse()"
                      class="border-b pb-3 w-full cursor-pointer hover:bg-gray-100">
                      <td class="px-4 py-3">
                        {{ (current_page - 1) * 10 + (index + 1) }}
                      </td>
                      <td class="px-4 py-3">{{ course.title }}</td>
                      <td class="px-4 py-3 hidden">
                        {{ course.short_description }}
                      </td>
                      <td class="px-4 py-3">{{ course.course_code }}</td>
                      <td class="px-4 py-3">{{ course.class_section }}</td>
                      <td class="px-4 py-3">
                        {{ formatDate(course.updated_at) }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="bg-[#18469d]">
                      <td colspan="5" class="p-4"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <Pagination :totalPages="totalPages" ref="paginationRef" @page-changed="this.getCourses" />
            </div>
          </div>

          <!-- <div class="flex flex-col gap-5 w-[500px]">
            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg1.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Total Students:
                  <span class="font-semibold text-blues">56</span></span
                >
              </p>
            </div>

            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg2.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Active Courses:
                  <span class="font-semibold text-blues">56</span></span
                >
              </p>
            </div>

            <div class="flex items-center gap-5">
              <img src="@/assets/newd/lg3.png" alt="" />
              <p>
                <span class="font-semibold text-base"
                  >Total Review:
                  <span class="font-semibold text-blues">56</span></span
                >
              </p>
            </div>
          </div> -->
        </div>
      </section>
    </div>

    <!-- <div class="mt-10 flex flex-col gap-10">
      <div class="flex items-center justify-center gap-10">
        <div class="flex items-center gap-2" @click="activeMenu = 'course'">
          <p
            class="text-base p-2 font-bold cursor-pointer"
            :class="{
              'border-b-2 border-blues text-blues': activeMenu == 'course',
            }"
          >
            Courses
          </p>
        </div>
        <div class="flex items-center gap-2" @click="activeMenu = 'mail'">
          <p
            class="text-base p-2 font-bold cursor-pointer"
            :class="{
              'border-b-2 border-blues text-blues': activeMenu == 'mail',
            }"
          >
            Send Mail
          </p>
        </div>
      </div>

      <div class="container mx-auto max-w-[1200px] pb-20">
        <form v-if="activeMenu == 'course'"
          ref="createTeamRef"
          @submit.prevent="invitepost"
          class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
        >
          <div class="flex flex-col gap-3 w-full">
            <label for="category" class="flex gap-2 items-center">
              <div>
                Course list
                <span class="text-red-400">*</span>
              </div>
            </label>
            <select
              name="course"
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
              id="course"
              required
            >
              <option value="" disabled selected>Select course</option>
              <option
                v-for="course in courselist"
                :key="course"
                :value="course.title"
              >
                <span> {{ course.title }}</span>
              </option>
            </select>
          </div>

          

          <div class="flex flex-col gap-3 w-full">
            <label for="studentmail" class="flex gap-2 items-center">
              <div>Student list <span class="text-red-400">*</span></div>
            </label>

            <input
              type="text"
              id="studentmail"
              v-model="searchQuery"
              @input="Studentsearch"
              placeholder="Search email"
              class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
            />
            <ul
              v-if="showdetail == false && this.studentlist.length > 0"
              class="bg-white w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1"
            >
              <li
                v-for="student in studentlist.slice(0, lengthCount)"
                :key="student.email"
                class="p-2 cursor-pointer hover:bg-gray-100"
                @click="selectStudent(student.email)"
              >
                {{ student.email }}
              </li>
            </ul>
          </div>

          <div class="flex justify-center pb-4 mt-3 gap-10">
            <button
              @click="closepopup"
              class="border text-gray-500 rounded-lg text-sm px-10 font-semibold py-2"
            >
              Close
            </button>
            <div class="flex gap-3 items-center">
              <button
                :disabled="disableStatus"
                :class="{
                  'cursor-not-allowed bg-gray-200 text-black':
                    disableStatus === true,
                  'cursor-pointer bg-blues text-white ':
                    disableStatus === false,
                }"
                type="submit"
                class="rounded-lg text-sm px-10 font-semibold py-2"
              >
                Invite
              </button>
              <div v-if="loaders" class="spinner"></div>
            </div>
          </div>
          <div
            v-if="invite_messages"
            class="text-green-500 font-bold text-left px-2 py-2 rounded-lg"
          >
            {{ invite_messages }}
          </div>
          <div
            v-if="invite_err_messages"
            class="text-red-500 font-bold text-left px-2 py-2 rounded-lg"
          >
            {{ invite_err_messages }}
          </div>
        </form>

        <form v-if="activeMenu == 'mail'"
          ref="mailref"
          @submit.prevent="sendmail"
          class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
        >
          

          <div
            class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
          >
            <div class="w-full flex flex-col gap-2">
              <input
                id="subject"
                placeholder="Subject"
                type="text"
                class="border rounded outline-none text-xs md:text-sm lg:text-base py-2 px-2"
                required
              />
            </div>
          </div>
          
          <div class="flex flex-col gap-2 w-full mt-2">
           
            <textarea
              textarea
              rows="12"
              cols="10"
              id="content"
              class="border border-gray-200 outline-none h-full w-full p-2 rounded"
              placeholder="Your message"
            ></textarea>
          </div>

          <div class="flex justify-start mt-4">
            <button
              type="submit"
              class="bg-blues px-8 py-2 text-sm text-white rounded-xl"
            >
              Send
            </button>
          </div>
        </form>

      </div>
    </div> -->

    <!-- PopUp -->
    <div v-if="popUp && updateDetails != null"
      class="fixed w-full min-h-screen bg-black bg-opacity-75 top-0 z-50 flex justify-center items-center">
      <div class="w-full md:w-5/6 lg:w-5/6 xl:w-3/6 2xl:w-2/6 h-full mx-auto flex flex-col items-center">
        <div class="bg-white p-8 rounded-lg shadow-md w-full max-w-md flex flex-col gap-3">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold mb-6 text-[#0085DB]">Edit Details</h2>
            <img class="h-5 w-5 md:h-8 md:w-8 cursor-pointer" @click="popUp = false" src="@/assets/closebutton.svg" />
          </div>
          <form class="">
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">Destination <span
                  class="text-red-400">*</span></label>
              <input type="text" v-model="updateDetails.designation"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="Student" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">Mobile <span class="text-red-400">*</span></label>
              <input type="text" v-model="updateDetails.mobile"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="123456789" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">Address <span
                  class="text-red-400">*</span></label>
              <input type="text" v-model="updateDetails.address"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="21/2, Interting street, Common city - 365986" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700">Description <span
                  class="text-red-400">*</span></label>
              <textarea v-model="updateDetails.description"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="My name is this you can ask me what event it sear tire" required></textarea>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">GitHub <span class="text-red-400">*</span></label>
              <input type="text" v-model="updateDetails.github"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="Link" required />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">LinkedIn <span
                  class="text-red-400">*</span></label>
              <input type="text" v-model="updateDetails.linkedin"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="Link" required />
            </div>
            <div class="flex justify-center items-center w-full">
              <button @click="SubmitProfile()" type="submit"
                class="w-full max-w-[118px] h-[40px] px-4 py-2 bg-[#0F172A] text-white rounded-md hover:bg-blue-700 transition">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="changePassword"
      class="fixed w-full min-h-screen bg-black bg-opacity-75 top-0 z-50 flex justify-center items-center">
      <div class="w-full md:w-5/6 lg:w-5/6 xl:w-3/6 2xl:w-2/6 h-full mx-auto flex flex-col items-center">
        <div class="bg-white p-8 rounded-lg shadow-md w-full max-w-md flex flex-col gap-3">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold mb-6 text-[#0085DB]">
              Change Password
            </h2>
            <img class="h-5 w-5 md:h-8 md:w-8 cursor-pointer" @click="changePassword = false"
              src="@/assets/closebutton.svg" />
          </div>
          <form @submit.prevent="changepassword">
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">Old Password <span
                  class="text-red-400">*</span></label>

              <div class="flex items-center relative">
                <input type="password" id="oldpassword" class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Old Password" required />

                <img v-if="passwordType == 'oldpassword'" src="@/assets/eyeslash.svg" @click="hideShow('oldpassword')"
                  alt="" class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
                <img v-else src="@/assets/eye.svg" @click="hideShow('oldpassword')" alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
              </div>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">New Password <span
                  class="text-red-400">*</span></label>
              <!-- <input
                type="password"
                id="oldtoNew"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="New Password"
                required
              />
              <img v-if="passwordType == 'password'" src="@/assets/eyeslash.svg" @click="hideShow('oldtoNew')"
                        alt="" class="cursor-pointer inline-block z-50" style="margin-left: -30px" />
                    <img v-else src="@/assets/eye.svg" @click="hideShow('oldtoNew')" alt=""
                        class="cursor-pointer inline-block z-50" style="margin-left: -30px" /> -->

              <div class="flex items-center relative">
                <input type="password" id="oldtoNew" class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  placeholder="New Password" required />

                <img v-if="passwordType == 'oldtoNew'" src="@/assets/eyeslash.svg" @click="hideShow('oldtoNew')" alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
                <img v-else src="@/assets/eye.svg" @click="hideShow('oldtoNew')" alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
              </div>
            </div>

            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]">New Confirm Password <span
                  class="text-red-400">*</span></label>

              <div class="flex items-center relative">
                <input type="password" id="changeconfirm"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="New Confirm Password"
                  required />

                <img v-if="passwordType == 'changeconfirm'" src="@/assets/eyeslash.svg"
                  @click="hideShow('changeconfirm')" alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
                <img v-else src="@/assets/eye.svg" @click="hideShow('changeconfirm')" alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4" />
              </div>

              <!-- <input
                type="password"
                id="changeconfirm"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="New Confirm Password"
                required
              />
              <img v-if="passwordType == 'password'" src="@/assets/eyeslash.svg" @click="hideShow('changeconfirm')"
                        alt="" class="cursor-pointer inline-block z-50" style="margin-left: -30px" />
                    <img v-else src="@/assets/eye.svg" @click="hideShow('changeconfirm')" alt=""
                        class="cursor-pointer inline-block z-50" style="margin-left: -30px" /> -->
            </div>

            <div class="flex justify-center items-center w-full">
              <button type="submit"
                class="w-full px-4 py-2 bg-[#0F172A] text-white rounded-md hover:bg-blue-700 transition">
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div id="image_uploads" class="bg-white rounded-lg shadow-sm w-[350px] outline-none">
      <!-- Your content here -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";
import { mapGetters, mapMutations } from "vuex";
import Header from "@/components/Admin/Header.vue";
import Pagination from "@/components/Pagination.vue";
import { faLaugh } from "@fortawesome/free-regular-svg-icons";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      messages: {
        text: "",
        type: "null",
      },
      selectedcontent: "Courses",
      courseDetails: null,
      boughtcourse: null,
      changePassword: false,
      passwordType: "password",
      activeMenu: "course",
      studentList: [],
      tabs: ["profile details", "accessible course"],
      active_tab: "profile details",
      course_list: "",
      totalPages: 1,
      current_page: 1,
      course_count: null,
      loading: false,
      selectedInstructors: [],
      changeProfile: false,
    };
  },

  components: {
    Header,
    FlashMessage,
    Pagination,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    await this.openProcess();
    await this.getCourses(1);
    // let tempvar_courselist = [];
    // await axios
    //   .get(`${process.env.VUE_APP_API}/courses/?format=json`)
    //   .then((response) => (this.courseDetails = response.data.data));

    // this.courseDetails = this.courseDetails.filter((course) => {
    //   if (tempvar_courselist.includes(course.id)) {
    //     return course;
    //   }
    // });

    // this.getstudentdetails();
  },

  methods: {

    ...mapMutations(["updateImage"]),

    // async getstudentdetails() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/all_list/${this.course_id}/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       console.log(response);
    //       this.studentList = response.data;
    //       this.loading=false;
    //     });
    // },

    async sendmail(event) {
      const HeaderVal = {
        subject: event.target.elements.subject.value,
        time: "",
        content_1: event.target.elements.content.value,
        content_2: "",
        content_3: "",
      };

      // await axios
      //   .post(
      //     `${process.env.VUE_APP_API}/instructor_send_personal/${this.mailid.id}/?Key=${this.userInfo.token_key}`,
      //     HeaderVal
      //   )
      //   .then((response) => {
      //     if (response.data.status == 200) {
      //       this.messages = {
      //         text: "Mail Sent successfully",
      //         type: "success",
      //       };
      //     } else {
      //       this.messages = {
      //         text: " Event Faild",
      //         type: "error",
      //       };
      //     }
      //   });

      await axios
        .post(
          `${process.env.VUE_APP_API}/user/notifications/?Key=${this.userInfo.token_key}`,
          {
            topic: event.target.elements.subject.value,
            message: event.target.elements.content.value,
            user_id: [this.userInfo.user.id],
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      this.$refs.mailref.reset();
      this.popUp = false;
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },

    hideShow(id) {
      const passwordField = document.querySelector(`#${id}`);
      passwordField.getAttribute("type") === "password"
        ? passwordField.setAttribute("type", "text")
        : passwordField.setAttribute("type", "password");

      if (this.passwordType == id) {
        this.passwordType = "password";
      } else {
        this.passwordType = id;
      }
    },

    ChangePasswordPopup() {
      this.changePassword = true;
    },

    async changepassword() {
      let oldpassWord = document.querySelector("#oldpassword").value;
      let newpassword = document.querySelector("#oldtoNew").value;
      let confirmpassword = document.querySelector("#changeconfirm").value;
      if (newpassword == confirmpassword) {
        var responseMail;
        let loginHeader = {
          username: this.userInfo.user.email,
          password: oldpassWord,
        };
        // OldPassword Validations

        await axios
          .post(`${process.env.VUE_APP_API}/login`, loginHeader)
          .then((response) => {
            if (response.data.user) {
              responseMail = response.data.user.email;
            } else {
              responseMail = "error";
            }
          });

        if (responseMail == this.userInfo.user.email) {
          const headerVal = {
            old_password: document.querySelector("#oldpassword").value,
            new_password: document.querySelector("#changeconfirm").value,
          };
          await axios
            .put(
              `${process.env.VUE_APP_API}/api/change-password/?Key=${this.userInfo.token_key}`,
              headerVal
            )
            .then((response) => {
              if (response.data.message == "Password updated successfully") {
                this.messages = {
                  text: "Password updated successfully",
                  type: "success",
                };
              } else {
                this.messages = {
                  text: " Event Faild",
                  type: "error",
                };
              }
            })
            .catch((error) => {
              console.log(error);
            });
          document.querySelector("#oldpassword").value = "";
          document.querySelector("#oldtoNew").value = "";
          document.querySelector("#changeconfirm").value = "";

          this.changePassword = false;

          setTimeout(() => {
            this.messages = {
              text: " ",
              type: "",
            };
            // this.$router.push({
            //     name: 'Home'
            // })
          }, 3000);
        } else {
          this.errorMessage = {
            text: " Old Password Not Matching",
            type: "error",
          };

          setTimeout(() => {
            this.errorMessage = {
              text: " ",
              type: "",
            };
          }, 1500);
        }
      } else {
        console.log("error");
        this.errorMessage = {
          text: " Confirm Password Miss Match",
          type: "error",
        };
        setTimeout(() => {
          this.errorMessage = {
            text: " ",
            type: "",
          };
        }, 1500);
      }
    },

    async imageHandles() {
      this.profile = false;
      let headerprofile = new FormData();
      headerprofile.append("id", this.userInfo.user.id);
      headerprofile.append(
        "profile",
        document.querySelector("#image_uploads").files[0]
      );

      await axios
        .put(
          `${process.env.VUE_APP_API}/upload_photo/?Key=${this.userInfo.token_key}`,
          headerprofile
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
            this.openProcess();
            this.updateImage(`${response.data.data.profile}`);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .catch((error) => {
          this.messages = { 
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        // this.openProcess();
        this.changeProfile = false;
        // window.location.reload();
        // setTimeout(()=>{
        //   this.updateImage(this.profileInfo.data.profile);
        // }, 50)        
      }, 3000);
    },
    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
    },

    async onUpload() {
      // upload file
      await axios.post("my-domain.com/file-upload", this.selectedFile);
    },

    async openProcess() {
      axios
        .get(
          `${process.env.VUE_APP_API}/paymentlist/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          console.log(res);
          this.tnxDetails = res.data;
        });
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`
        )
        .then((response) => (this.profileInfo = response.data));
    },

    async ProfileEdit() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      this.popUp = true;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_update/${details_id}?Key=${token}&format=json`
        )
        .then((response) => (this.updateDetails = response.data.data));
      console.log("this.updateDetails123", this.updateDetails);
    },

    async SubmitProfile() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      let update = this.updateDetails;
      this.popUp = false;
      // console.log("updateDetails",updateDetails)

      await axios
        .put(
          `${process.env.VUE_APP_API}/profile_update/${details_id}/?Key=${token}&format=json`,
          update
        )
        .then((response) => {
          if (response.data.message == "Profile updated successfully") {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.openProcess();
      }, 3000);
    },
    // access course

    async getCourses(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.data.data.status == 200) {
            this.totalPages = response.data.data.total_page;
            this.current_page = response.data.data.current_page;
            this.course_list = response.data.data.data.data;
            this.selectedInstructors = this.course_list;
            this.course_count = response.data.data.total;
            this.loading = false;
          } else if (response.data.status == 400) {
            this.course_count = 0;
            this.course_list = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
/* #image_uploads {
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 4px black;
  width: 350px;
  outline: none;
} */

</style>
